export enum ConditionType {
	BEHAVIOUR = 'BEHAVIOUR',
	BOYS = 'BOYS',
	DEV_DISORDER = 'DEV_DISORDER',
	FYSICAL = 'FYSICAL',
	GIRLS = 'GIRLS',
	MENTAL_DISABILITY = 'MENTAL_DISABILITY',
	SPECIFIC = 'SPECIFIC',
	VULNERABILITY = 'VULNERABILITY',
}

export const CONDITION_TYPES_EXCLUSIVE = [
	ConditionType.BEHAVIOUR,
	ConditionType.BOYS,
	ConditionType.DEV_DISORDER,
	ConditionType.FYSICAL,
	ConditionType.GIRLS,
	ConditionType.MENTAL_DISABILITY,
	ConditionType.SPECIFIC,
	ConditionType.VULNERABILITY,
];

export const CONDITION_TYPES_INCLUSIVE = [
	ConditionType.BEHAVIOUR,
	ConditionType.DEV_DISORDER,
	ConditionType.FYSICAL,
	ConditionType.MENTAL_DISABILITY,
	ConditionType.SPECIFIC,
	ConditionType.VULNERABILITY,
];
